import { resourceExplorerDataByViewIdSelector } from "./resourceExplorerDataByViewIdSelector";
import { RootState } from "../../../../store";

export const budgetChartDataLoadingSelector = (state: RootState) => {
  return resourceExplorerDataByViewIdSelector(state)?.isLoading;
};
